const EVENT_NAME_VIEW_ITEM = 'view_item';

window.onGtmReady(function() {
  try {
    window.dataLayer.push({
      event: EVENT_NAME_VIEW_ITEM,
      ecommerce: {
        currency: window.gtmConfig.currency,
        items: [window.gtmConfig.product]
      }
    });

    console.log(`✓ GTM event ${EVENT_NAME_VIEW_ITEM} pushed to dataLayer.`);
  } catch (error) {
    console.error(`Error tracking ${EVENT_NAME_VIEW_ITEM}:`, error);
  }
});
